import * as path from "../paths";
import { client } from "../client";

export const newPost = (data) => {
  return client
    .post(path.NEW_POST, data)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
export const getAllVideos = (
  id,
  page,
  oneVideoPerUser = false,
  latestSixVideos = false,
) => {
  return client
    .get(
      `${path.GET_ALL_VIDEOS}?page=${page}${id ? `&id=${id}` : ""}${
        oneVideoPerUser ? "&oneVideoPerUser=true" : ""
      }${latestSixVideos ? "&latestSixVideos=true" : ""}`,
    )
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

// export const editPost = (data, postId) => {
//   return client
//     .patch(url.EDIT_POST + postId, data)
//     .then((result) => {
//       return result;
//     })
//     .catch((err) => {
//       return err.response;
//     });
// };

export const deletePost = (postId) => {
  return client
    .delete(path.DELETE_POST + postId)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const likePost = (postId) => {
  return client
    .post(path.LIKE_POST + postId)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
export const unlikePost = (postId) => {
  return client
    .patch(path.UNLIKE_POST + postId)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const ratePost = (data, postId) => {
  return client
    .post(path.RATE_POST + postId, data)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const pollVote = (data, postId) => {
  return client
    .post(path.POLL_VOTE + postId, data)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
export const newReply = (data, postId) => {
  return client
    .post(path.NEW_REPLY + postId, data)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getAllPosts = async (page) => {
  return await client
    .get(path.GET_ALL_POSTS + page)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getTrendingPosts = async (page) => {
  return await client
    .get(path.GET_ALL_POSTS + page + "&trending=true")
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getPollPosts = async (page) => {
  return await client
    .get(path.GET_ALL_POSTS + page + "&poll=true")
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getRacePosts = async (page) => {
  return await client
    .get(path.GET_ALL_POSTS + page + "&race=true")
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getMarketPosts = async (page) => {
  return await client
    .get(path.GET_ALL_POSTS + page + "&market=true")
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const searchPosts = async (query, page) => {
  return await client
    .get(`${path.SEARCH_POSTS}?query=${query}&page=${page}`)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
export const getHashtagPosts = async (tag, page) => {
  return await client
    .get(path.GET_ALL_POSTS + page + "&tag=" + tag)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
export const getFollowingPosts = (page) => {
  return client
    .get(path.GET_FOLLOWING_POSTS + page)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getPostById = (postId) => {
  return client
    .get(path.GET_POST_ID + postId)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
export const getProfilePosts = (username) => {
  return client
    .get(path.GET_PROFILE_POSTS + username)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};
export const getProfileReplies = (username) => {
  return client
    .get(path.GET_PROFILE_REPLIES + username)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const repost = (postId) => {
  return client
    .post(path.REPOST + postId)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const getTrends = () => {
  return client
    .get(path.GET_TRENDS)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.response;
    });
};

export const deleteTrend = (tag) => {
  return client
    .delete(path.DELETE_TREND + encodeURIComponent(tag))
    .then((result) => result)
    .catch((err) => err.response);
};

// Admin-only functions for pinning and featuring posts
export const pinPost = (postId) => {
  return client
    .post(path.PIN_POST + postId)
    .then((result) => result)
    .catch((err) => err.response);
};

export const unpinPost = (postId) => {
  return client
    .post(path.UNPIN_POST + postId)
    .then((result) => result)
    .catch((err) => err.response);
};

export const featurePost = (postId) => {
  return client
    .post(path.FEATURE_POST + postId)
    .then((result) => result)
    .catch((err) => err.response);
};

export const unfeaturePost = (postId) => {
  return client
    .post(path.UNFEATURE_POST + postId)
    .then((result) => result)
    .catch((err) => err.response);
};

export const hidePost = (postId) => {
  return client
    .post(path.HIDE_POST + postId)
    .then((result) => result)
    .catch((err) => err.response);
};

export const unhidePost = (postId) => {
  return client
    .post(path.UNHIDE_POST + postId)
    .then((result) => result)
    .catch((err) => err.response);
};

